import { render, staticRenderFns } from "./RegionThresholdConfigView.vue?vue&type=template&id=f99708ba&"
import script from "./RegionThresholdConfigView.vue?vue&type=script&lang=js&"
export * from "./RegionThresholdConfigView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports